import type { Components, Theme as MuiTheme } from '@mui/material';

export const popoverTheme: Components<MuiTheme> = {
  MuiPopover: {
    variants: [
      {
        props: { variant: 'mobile-centered' },
        style: ({ theme }) => ({
          '& .MuiPaper-root': {
            [theme.breakpoints.down('sm')]: {
              left: '50% !important',
              transform: 'translateX(-50%) !important',
            },
          },
        }),
      },
    ],
  },
};
